import { render, staticRenderFns } from "./CMSBlogSubCategoryForm.vue?vue&type=template&id=dc45cd00&"
import script from "./CMSBlogSubCategoryForm.vue?vue&type=script&lang=js&"
export * from "./CMSBlogSubCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports